function Peru({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1901)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M32 16.0008C32 9.12147 27.658 3.25672 21.5652 0.996094V31.0058C27.658 28.745 32 22.8803 32 16.0008V16.0008Z" fill="#D80027"/>
  <path d="M0 16.0008C0 22.8803 4.342 28.745 10.4348 31.0057V0.996094C4.342 3.25672 0 9.12147 0 16.0008V16.0008Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Peru;
